var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", [
    _c("table", { staticClass: "table" }, [
      _c("tbody", [
        _c("tr", [
          _c(
            "td",
            { staticClass: "align-middle" },
            [
              _c("ConsistencyAnalysisCircles", {
                attrs: { status: "Inconsistent" },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _vm._m(0),
        ]),
        _vm._v(" "),
        _c("tr", [
          _c(
            "td",
            { staticClass: "align-middle" },
            [
              _c("ConsistencyAnalysisCircles", {
                attrs: { status: "Acceptable" },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _vm._m(1),
        ]),
        _vm._v(" "),
        _c("tr", [
          _c(
            "td",
            { staticClass: "align-middle" },
            [
              _c("ConsistencyAnalysisCircles", {
                attrs: { status: "Consistent" },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _vm._m(2),
        ]),
        _vm._v(" "),
        _c("tr", [
          _c(
            "td",
            { staticClass: "align-middle" },
            [
              _c("ConsistencyAnalysisCircles", {
                attrs: { status: "Unknown" },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _vm._m(3),
        ]),
      ]),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("td", [
      _c("strong", [_vm._v("Inconsistency score: above 20%")]),
      _c("br"),
      _vm._v(
        "\n                    Your answers are inconsistent.\n                    We recommend you go back and revisit the questions that are contributing most to your inconsistency score.\n                    The software will highlight the key questions for you.\n                "
      ),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("td", [
      _c("strong", [_vm._v("Inconsistency score: 10-20%")]),
      _c("br"),
      _vm._v(
        '\n                    Your inconsistency is a little higher than it should be. If your decision involves lots of "highly subjective" issues,\n                    this level of inconsistency might be okay - to be human is to be inconsistent!\n                    If your decision is mostly driven by "hard numbers", your consistency should be lower - you may want to go back and review your answers to key questions.\n                '
      ),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("td", [
      _c("strong", [_vm._v("Inconsistency score: below 10%")]),
      _c("br"),
      _vm._v(
        "\n                    Great job! The consistency of your answers is good!\n                "
      ),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("td", [
      _c("strong", [_vm._v("Inconsistency score: Unknown")]),
      _c("br"),
      _vm._v(
        "\n                    Not enough data to calculate it.\n                "
      ),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }